import React from "react";
import CheckIcon from "./CheckIcon";

/**
 * "sec-svc-list" card grid on a service page.
 * @param {string} [eyebrow] optional heading block above the grid
 * @param {string} [heading] optional heading block above the grid
 * @param {{title: string, text: string}[]} items
 */
export default function ServiceFeatures({ eyebrow, heading, items = [] }) {
    return (
        <section className="container sec-svc-list">
            {heading && (
                <div className="center mb-44">
                    <div className="eyebrow">{eyebrow}</div>
                    <h2 className="h-lg">{heading}</h2>
                </div>
            )}
            <div className="svc-list">
                {items.map((item) => (
                    <div className="svc-list-item card" key={item.title}>
                        <div className="ico">
                            <CheckIcon />
                        </div>
                        <div>
                            <h3>{item.title}</h3>
                            <p>{item.text}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
